import { render } from "./InfinityScroll.vue?vue&type=template&id=4ecb8a3d&ts=true"
import script from "./InfinityScroll.vue?vue&type=script&lang=ts"
export * from "./InfinityScroll.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__